import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import ResolveXeroContactsHtml from './xero.resolve-contacts.html';
import XeroSettingsHtml        from './xero.settings.html';

export function XeroStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller    : 'XeroSettingsCtrl',
    name          : 'app.xero-settings',
    reloadOnSearch: false,
    templateUrl   : XeroSettingsHtml,
    url           : '/xero_settings?new_user',
    resolve       : {
      accountingSettings: ( $rootScope : any ) : ng.IPromise<any> => $rootScope.Company.getAccountingSettings(),
      paymentTypes      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/invoice_payment_methods'),
      session           : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  })
  .state({
    controller : 'ResolveXeroContactsCtrl',
    name       : 'app.xero-contacts',
    templateUrl: ResolveXeroContactsHtml,
    url        : '/xero_contacts',
    resolve    : {
      contacts: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('temporary_xero_contacts', [0, 10]),
      count   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('temporary_xero_contacts/count')
    }
  });
}